<template>
     <a-table
        :columns="columns"
        :data-source="data"
        class="tableborder"
    >
        <template slot="operation">
            <span class="csP" style="color:#7ebae5">回复</span>
        </template>
    </a-table>
</template>
<script>
const columns = [
  {
    title: '科目名称',
    dataIndex: 'name',
  }, {
    title: '分类',
    dataIndex: 'age',
  }, {
    title: '题库',
    dataIndex: 'wechart',
  }, {
    title: '视频',
    dataIndex: 'status',
  }, {
    title: '讲义',
    dataIndex: 'status1',
  }, {
    title: '操作',
    dataIndex: 'operation',
    scopedSlots: { customRender: 'operation' },
  }
];
export default {
    name: 'subjectNum',
    data(){
        return{
            columns,
            data:[]
        }
    }
}
</script>